import OktaAuth from '@okta/okta-auth-js';

import oktaConfig from 'common/constants/config/okta';

export default () =>
  new OktaAuth({
    ...oktaConfig.oidc,
  });
